import { render, staticRenderFns } from "./IpQcList.vue?vue&type=template&id=72aa77bc"
import script from "./IpQcList.vue?vue&type=script&lang=js"
export * from "./IpQcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports